"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Img = void 0;
var React = require("react");
var useUpdated_1 = require("../hooks/useUpdated");
var onOnline_1 = require("../utils/onOnline");
function Img(props) {
    var _a = __read(React.useState('default'), 2), loadType = _a[0], setLoadType = _a[1];
    useUpdated_1.useUpdated(function () {
        if (loadType === 'reset') {
            setLoadType('default');
        }
    }, [loadType]);
    var handleError = React.useCallback(function (e) {
        var _a;
        setLoadType('error');
        onOnline_1.onOnline(function () {
            setLoadType('reset');
        });
        return (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }, [props.onError]);
    return (React.createElement("img", __assign({}, props, { onError: handleError, src: loadType === 'reset' ? undefined : props.src })));
}
exports.Img = Img;
//# sourceMappingURL=Img.js.map